import Gt from "./filter-set.js";
export default class Ht {
  constructor(t, s) {
    (this.Bl = t), (this.Gl = s);
  }
  Jl(t) {
    if (null == this.Bl || null == this.Gl) return !1;
    const s = t[0],
      r = t[1];
    return s === this.Bl && this.Gl.Jl(r);
  }
  static fromJson(t) {
    return new Ht(
      t ? t.event_name : null,
      t ? Gt.fromJson(t.property_filters) : null
    );
  }
  ss() {
    return { e: this.Bl, pf: this.Gl.ss() };
  }
}
